import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useClearButtonStyles = makeStyles(({ palette }) =>
  createStyles({
    clearButton: {
      color: palette.error.main,
    },
  })
);

export default useClearButtonStyles;
